export { AdultosOnboardingPhone } from "./AdultosOnboardingPhone";
